export default () => {
  return {
    adminProfile: {},
    isAuthenticated: false,
  };
};
